export default {
  notAllNumbersAreSpecifiedErrorMessage:
    'You have to specify a valid phone number for each attendee to enable two-factor authentication.',
  notValidPhoneNumber: 'Please specify a valid phone number.',
  notValidCountry: 'You have to choose a country.',
  notValidConferencePhoneNumber: 'You have to choose a conference phone number.',
  notSupportedLanguageHuman:
    'Selected transcription mechanism is not supperted for the chosen language',
  notSupportedLanguageAI:
    'Selected transcription mechanism is not supperted for the chosen language',
};



// WEBPACK FOOTER //
// ./config/validation-messages-constants.js